import React from 'react';
import { Grid, MenuItem, Divider, Button, Box } from '@mui/material';
import { styles } from './styles';
import { Plus } from '../../../assets/icons/plus';
import { Remove } from '../../../assets/icons/remove';
import TextField from '../../../components/common/InputField/TextField';

const MAX_DESIGNATIONS = 10;

const getFieldError = (serverFieldErrors, touched, errors, index, field) =>
    serverFieldErrors?.[index]?.[field] || (touched?.[index]?.[field] && errors?.[index]?.[field]) || '';

const DesignationFields = (props) => {
    const {
        designations,
        setDesignations,
        statusOptions,
        errors,
        touched,
        serverFieldErrors = [],
        onBlur,
        onClearServerError,
    } = props;

    const handleAdd = () => {
        if (designations.length >= MAX_DESIGNATIONS) return;
        setDesignations([
            ...designations,
            {
                name: '',
                status: 'Active',
            },
        ]);
    };

    const handleChange = (index, value, type) => {
        if (type === 'name') onClearServerError?.(index);
        const updated = [...designations];
        updated[index] = { ...updated[index], [type]: value };
        setDesignations(updated);
    };

    const handleRemove = (index) => {
        const updated = [...designations];
        updated.splice(index, 1);
        setDesignations(updated);
    };

    return (
        <>
            <Grid
                item
                sx={{
                    display: 'flex',
                    justifyContent: 'right',
                    alignItems: 'center',
                    width: '100%',
                    pt: '0px !important',
                }}
            >
                <Button
                    color="primary"
                    disabled={designations.length >= MAX_DESIGNATIONS}
                    onClick={handleAdd}
                    size="large"
                    variant="text"
                    startIcon={<Plus />}
                >
                    Add Designation
                </Button>
            </Grid>
            <Grid item xs={12} sx={{ pt: '0px !important' }}>
                {designations.map((item, index) => {
                    const nameError = getFieldError(serverFieldErrors, touched, errors, index, 'name');
                    const statusError = getFieldError(serverFieldErrors, touched, errors, index, 'status');

                    return (
                    <Grid container spacing={6} pt="24px" key={index}>
                        <Grid item xs={4}>
                            <TextField
                                error={Boolean(nameError)}
                                fullWidth
                                helperText={nameError}
                                label="Name"
                                name={`designations[${index}].name`}
                                onBlur={() => onBlur?.(`designations[${index}].name`)}
                                onChange={(event) => handleChange(index, event.target.value, 'name')}
                                value={item.name}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                error={Boolean(statusError)}
                                label="Status"
                                name={`designations[${index}].status`}
                                helperText={statusError}
                                onBlur={() => onBlur?.(`designations[${index}].status`)}
                                onChange={(event) => handleChange(index, event.target.value, 'status')}
                                select
                                value={item.status}
                            >
                                {statusOptions.map((status) => (
                                    <MenuItem key={status} value={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {designations.length > 1 && (
                            <Grid item xs={4}>
                                <Box sx={styles.removeButtonBox}>
                                    <Button
                                        onClick={() => handleRemove(index)}
                                        size="large"
                                        sx={styles.removeButton}
                                        variant="text"
                                        startIcon={<Remove />}
                                    >
                                        Remove
                                    </Button>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                    );
                })}
            </Grid>
            <Grid item sx={styles.dividerWrapper}>
                <Divider flexItem orientation="horizontal" sx={styles.divider} />
            </Grid>
        </>
    );
};

export default React.memo(DesignationFields);
